export default {
  namespaced      : true,
  
  state           : {
    isOpenModal     : false,
    templateName    : null,
    meta            : {},

    infomation  : {
      title           : '',
      description     : '',
      itemStatus      : '',
      itemName        : '',
      itemSlug        : '',
      quantity        : 1,
      total           : 1,
      remain          : 0,
    },

    templateSet     : {
      addBadgeToPodMessage  : {
        title       : 'アイテム消費の確認',
        description : 'メッセージに「[[itemName]]」を【[[quantity]]つ】付与します。',
        itemStatus  : '消費アイテム：[[itemName]] 消費後の残量：[[remain]]個',
        itemName    : '[[itemName]]',
        itemSlug    : '[[itemImageSlug]]',
        quantity    : 1,
        total       : 1,
        remain      : 0,
      },

      addCharacterToPodRoom  : {
        title       : 'アイテム消費の確認',
        description : 'キャラクターをメルティングポッドに追加します。',
        itemStatus  : '消費アイテム：[[itemName]] 消費後の残量：[[remain]]個',
        itemName    : '[[itemName]]',
        itemSlug    : '[[itemImageSlug]]',
        quantity    : 1,
        total       : 1,
        remain      : 0,
      },

      createNewPark  : {
        title       : 'アイテム消費の確認',
        description : 'ひろばの新設申請を行います。申請が承認されない場合、アイテムは返却されます。',
        itemStatus  : '消費アイテム：[[itemName]] 消費後の残量：[[remain]]個',
        itemName    : '[[itemName]]',
        itemSlug    : '[[itemImageSlug]]',
        quantity    : 1,
        total       : 1,
        remain      : 0,
      }
    },
    
    handleSubmitFunction  : null,
    handleCancelFunction  : null,

    isSubmitLoading         : false,
    isModalFreez            : false,
    
    isDisabledSubmitButton  : false,

    lineMessage             : null
  },

  mutations       : {
    setOpenModal(state, value){
      state.isOpenModal = value;
    },

    setTemplateName(state, value){
      state.templateName = value;
    },

    setMeta(state, data){
      state.meta = data;
    },

    setInfomation(state){
      if(state.templateName === null) return;

      // 対象のテンプレート情報を取得し挿入します。
      for(let infoKey in state.infomation){
        if(typeof state.templateSet[state.templateName][infoKey] !== 'undefined'){
          state.infomation[infoKey] = state.templateSet[state.templateName][infoKey];
        }
      }

      // Infoを１つづつmeta情報をreplaceしていきます。
      for(let infoKey in state.infomation){
        if(typeof state.infomation[infoKey] !== 'string') continue;

        for(let metaKey in state.meta){
          const regex = new RegExp("\\[\\["+metaKey+"\\]\\]", 'g');

          state.infomation[infoKey] = state.infomation[infoKey].replace(regex, state.meta[metaKey]);
        }
      }
    },

    setHandleSubmitFunction(state, data){
      state.handleSubmitFunction = data;
    },

    setHandleCancelFunction(state, data){
      state.handleCancelFunction = data;
    },

    setIsSubmitLoading(state, value){
      state.isSubmitLoading = value;
    },

    setIsModalFreez(state, value){
      state.isModalFreez = value;
    },

    setIsDisabledSubmitButton(state, value){
      state.isDisabledSubmitButton = value;
    },

    setLineMessage(state, value){
      state.lineMessage = value;
    },

    resetStore(state){
      state.isOpenModal             = false;
      state.templateName            = null;
      state.meta                    = {};
      state.infomation.title        = '';
      state.infomation.description  = '';
      state.infomation.itemStatus   = '';
      state.infomation.itemName     = '';
      state.infomation.itemSlug     = '';
      state.infomation.quantity     = 1;
      state.infomation.total        = 1;
      state.infomation.remain       = 0;

      state.handleSubmitFunction    = null;
      state.handleCancelFunction    = null;
      state.isSubmitLoading         = false;
      state.isModalFreez            = false;
      state.isDisabledSubmitButton  = false;
      state.lineMessage             = null;
    }
  },

  actions         : {
    updateOpenModal(context, payload){
      if(typeof payload.value !== 'undefined'){
        context.commit('setOpenModal', payload.value);
      }

      if(typeof payload.templateName !== 'undefined'){
        context.commit('setTemplateName', payload.templateName);
      }

      if(typeof payload.meta !== 'undefined'){
        context.commit('setMeta', payload.meta);
      }

      if(typeof payload.handleSubmitFunction !== 'undefined'){
        context.commit('setHandleSubmitFunction', payload.handleSubmitFunction);
      }

      if(typeof payload.handleCancelFunction !== 'undefined'){
        context.commit('setHandleCancelFunction', payload.handleCancelFunction);
      }

      if(typeof payload.isSubmitLoading !== 'undefined'){
        context.commit('setIsSubmitLoading', payload.isSubmitLoading);
      }

      if(typeof payload.isModalFreez !== 'undefined'){
        context.commit('setIsModalFreez', payload.isModalFreez);
      }

      if(typeof payload.isDisabledSubmimtbutton !== 'undefined'){
        context.commit('setIsDisabledSubmitButton', payload.isDisabledSubmimtbutton);
      }

      if(typeof payload.lineMessage !== 'undefined'){
        context.commit('setLineMessage', payload.lineMessage);
      }

      context.commit('setInfomation');
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}